import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { Calendar } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function PhotographersEventsPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Eventos"
      description="Gerencie os eventos de fotografia e vídeo."
      icon={Calendar}
    />
  
    </MainLayout>);
}

